
import { Button, Input, Toast } from 'antd-mobile';
import { EyeInvisibleOutline, EyeOutline, MailFill } from 'antd-mobile-icons'
import './index.scss'
import { useEffect, useState } from 'react';
import LoginEmail from './email';
import { loginCheck, loginPhone } from './api';
const Login = () => {
    const [visible, setVisible] = useState(false);
    const [visibleEmail, setVisibleeEmail] = useState(false);
    const [userName, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const loginPhoneApi = () => {
        loginPhone({ phone: userName, password }).then(res => {
            if (res.code) {
                Toast.show({
                    icon: 'fail',
                    content: <>{res.msg.split('\n').map((item,index) => <div key={index}>{item}</div>)}</>,
                })
            }else{
                window.location.href = '/#/home'
              }
        })
    }
    useEffect(()=>{
        loginCheck().then(res=>{
            if(!res.code){
                window.location.href = '/#/home'
            }
        })
    },[])
    return <div className='login'>
        <div className='loginAnnimate'>
            <div className='login-tip'>
                <div>密码登录</div>
                <div>未注册过的手机将自动创建为新账号</div>
            </div>
            <div className="login-form">
                <div className='login-form-passName'>
                    <Input
                        value={userName}
                        style={{ '--color': 'black' }}
                        placeholder='请输入手机号'
                        onChange={(val) => setUserName(val.replace(/[^\d]/g, ''))}
                    />
                </div>
                <div className="login-form-passWord">
                    <Input
                        value={password}
                        onChange={(val) => setPassword(val.replace(/\s+/g, ''))}
                        style={{ '--color': 'black' }}
                        placeholder='请输入密码(6-20位)'
                        clearable
                        type={visible ? '' : 'password'}
                    />
                    <div style={{ fontSize: '1.6rem' }}>
                        {!visible ? (
                            <EyeInvisibleOutline onClick={() => setVisible(true)} />
                        ) : (
                            <EyeOutline onClick={() => setVisible(false)} />
                        )}
                    </div>
                </div>
            </div>
            <div className="login-btn">
                <Button onClick={loginPhoneApi} style={{ height: '5rem' }} block>登录</Button>
            </div>
        </div>
        <div className="login-type">
            <span>— 其他方式登录 —</span>
            <div className="login-type-icon">
                <div>
                    <MailFill color='#ef4855' onClick={() => setVisibleeEmail(true)} />
                    <LoginEmail visible={visibleEmail} setVisible={setVisibleeEmail} />
                </div>
            </div>
        </div>
    </div>
}
export default Login;